import { LocationImport } from "planning-portal-library/src/lib/core/domain/models/location-import.model";
import { Mapper } from "../../../../../core/base";
import { LocationImportWebEntity } from "./location-import.web-entity";

export class LocationImportMapper extends Mapper<
  LocationImportWebEntity,
  LocationImport
> {
  mapFrom(param: LocationImportWebEntity): LocationImport {
    return {
      activityName: param.activityName,
      address: param.address || '',
      city: param.city || '',
      country: param.country || '',
      deliveryCapacityType1: param.deliveryCapacityType1 || 0,
      deliveryCapacityType2: param.deliveryCapacityType2 || 0,
      deliveryCapacityType3: param.deliveryCapacityType3 || 0,
      id: param.id || '',
      latitude: param.latitude || 0.0,
      longitude: param.longitude || 0.0,
      locationId: param.locationId || '',
      locationName: param.locationName || '',
      openingHours: param.openingHours || '',
      pickupCapacityType1: param.pickupCapacityType1 || 0,
      pickupCapacityType2: param.deliveryCapacityType2 || 0,
      pickupCapacityType3: param.deliveryCapacityType3 || 0,
      postalCode: param.postalCode || '',
      productId: param.productId,
      productName: param.productName || '',
      serviceFromTime: param.serviceFromTime,
      serviceStopTime: param.serviceStopTime,
      serviceToTime: param.serviceToTime,
      stopTime: param.stopTime || ''
    };
  }

  mapTo(param: LocationImport): LocationImportWebEntity {
    return {
      activityName: param.activityName,
      address: param.address,
      city: param.city,
      country: param.country,
      deliveryCapacityType1: param.deliveryCapacityType1,
      deliveryCapacityType2: param.deliveryCapacityType2,
      deliveryCapacityType3: param.deliveryCapacityType3,
      id: param.id,
      latitude: param.latitude,
      longitude: param.longitude,
      locationId: param.locationId,
      locationName: param.locationName,
      openingHours: param.openingHours,
      pickupCapacityType1: param.pickupCapacityType1,
      pickupCapacityType2: param.deliveryCapacityType2,
      pickupCapacityType3: param.deliveryCapacityType3,
      postalCode: param.postalCode,
      productId: param.productId,
      productName: param.productName,
      serviceFromTime: param.serviceFromTime,
      serviceStopTime: param.serviceStopTime,
      serviceToTime: param.serviceToTime,
      stopTime: param.stopTime
    };
  }
}
